import { combineReducers } from 'redux';

const bannerListInitialState = {
  loadStatus: 0,
  list: null,
};

function bannerListReducer(state = bannerListInitialState, action) {
  switch (action.type) {
    case 'LOAD_UPGRADE_BANNER_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_UPGRADE_BANNER_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  banners: bannerListReducer,
});
